import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { servicedeskProformaIssueFormsDirectRoute } from '@jira/router-routes__proforma-routes/src/servicedeskProformaIssueFormsDirectRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { proformaIssueFormsDirectPageEntryPoint } from './ui/issue-forms-direct/index.tsx';

export const servicedeskProformaIssueFormsDirectRouteEntry: Route = createEntry(
	servicedeskProformaIssueFormsDirectRoute,
	() => ({
		group: 'servicedesk',
		layout: serviceProjectLayout,
		// eslint-disable-next-line jira/router/no-project-context-resource
		resources: [...jiraSpaResources(), projectContextResource],

		navigation: {
			menuId: MenuIdProjects,
		},

		entryPoint: () => proformaIssueFormsDirectPageEntryPoint,
		perfMetricKey: 'issue-forms-direct',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
